class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ==========================================================================
   PUENTE DEL CAJÓN — 2026-08-30. Arreglos y agregados del 2026-09-01.

   CONTEXTO QUE EXPLICA CASI TODO. Este tema NO es Dawn estándar:
    a) El botón AGREGAR de las landings tiene su PROPIO manejador, escrito para la
       notificación vieja. Sigue vivo y sigue procesando cada respuesta de
       /cart/add.js. No se lo puede ignorar ni pisar: hay que convivir con él.
    b) El cajón se renderiza desde un SNIPPET en theme.liquid, no como sección.
    c) La clase `is-empty` vive en el ELEMENTO <cart-drawer>, no en .drawer__inner.

   ===== 1: VELOCIDAD =====
   "Tarda horas". NO era el servidor (/cart.js responde en 320 ms). El puente hacía
   DOS viajes en fila sin mostrar NADA. Ahora se piden las secciones del cajón en el
   MISMO /cart/add.js, se abre en el gesto del dedo con spinner, sin setTimeout. UN viaje.

   ===== 2: SE ABRÍA SOLO Y NO SE PODÍA CERRAR =====
   renderContents() TERMINA llamando a this.open(), siempre. Y el estado de carga
   ponía pointer-events:none a TODO, incluida la X. Ahora: se abre SOLO con gesto
   humano; pintar(secs, abrir) respeta `abrir`; la X nunca se bloquea + reloj de 8 s.

   ===== 3: SECCIONES PISADAS =====
   Al pedir las del cajón se PISABAN las de la página ('cart-notification-*') y su
   manejador escribía vacío encima. La regla no es ni respetar ni pisar: es SUMAR.

   ===== 4: is-empty EN EL ELEMENTO EQUIVOCADO =====
   Dawn la saca de .drawer__inner; acá vive en <cart-drawer>. `sincronizarVacio()` la
   sincroniza en los dos según si hay `.cart-item` real.

   ===== 5: SELECTOR DE REGALO GRANDE =====
   El ~90% de los compradores es unaware y los chips de texto pelado no le dicen nada
   (8,2% de los que calificaban se iban sin reclamar el regalo). Un botón abre un panel:
   el carrito se PLIEGA y el regalo se elige mirando fotos en un carrusel. El marcado y
   su CSS viven en snippets/barra-envio-gratis.liquid; acá solo el comportamiento, TODO
   delegado en document para sobrevivir a cada repintado.

   ===== 6: ⚠️ LA MINA — CÓMO SE AGREGA EL REGALO (2026-09-01) =====
   NUNCA agregar el regalo con el formato {items:[{id, quantity}]}.
   MEDIDO en la tienda real, mismo carrito, mismo token, respuesta 200:
     · {id: 45819450130485, quantity: 1}          -> 3 ítems, TODO convive.        OK
     · {items:[{id: 45819450130485, quantity:1}]} -> el carrito queda SOLO con el
       regalo: los perfumes PAGADOS desaparecen.                                 ROTO
   Con un perfume normal el formato items[] no rompe nada: es específico de este
   producto regalo (algo del lado del servidor lo trata distinto).
   La versión original de este puente usaba items[], así que los chips viejos tenían
   el mismo defecto: cada cliente que tocaba su regalo perdía el carrito entero.
   SI ALGÚN DÍA SE CAMBIA ESTA LÍNEA, probar SIEMPRE con 2 perfumes pagados adentro y
   confirmar que siguen ahí DESPUÉS de elegir el regalo.

   CÓMO VERIFICAR ESTO — LEER ANTES DE TOCAR NADA.
   `textContent` NO SIRVE: el texto de un elemento oculto también cuenta. Se verifica
   con GEOMETRÍA. Y ojo: el panel de navegador de la herramienta puede estar en
   innerWidth 0 / visibilityState hidden; ahí TODO mide 0 y ni se recalculan estilos.
   Chequear `window.innerWidth` antes de creerle a cualquier medición.

   OJO CON LA RECURSIÓN: el envoltorio escucha /cart/add|change|clear, así que las
   llamadas internas usan `fetchOriginal` y NO pasan por él. Los chips del regalo SÍ
   usan el fetch envuelto a propósito; no recursan porque el pedido sale por fetchOriginal.
   ========================================================================== */
(function () {
  var fetchOriginal = window.fetch ? window.fetch.bind(window) : null;
  if (!fetchOriginal) return;

  var SECCIONES = 'cart-drawer,cart-icon-bubble';

  function cajon() { return document.querySelector('cart-drawer'); }

  /* ---- regla de oro: sin dedo humano, el cajón no se abre ---------------- */
  var ultimoGesto = 0;
  function anotarGesto() { ultimoGesto = new Date().getTime(); }
  ['pointerdown', 'mousedown', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, anotarGesto, true);
  });
  function huboGesto() { return (new Date().getTime() - ultimoGesto) < 2000; }

  /* ---- la clase que decide si el cajón se VE ----------------------------- */
  function sincronizarVacio() {
    var d = cajon();
    if (!d) return;
    var hayItems = !!d.querySelector('.cart-item');
    var inner = d.querySelector('.drawer__inner');
    if (hayItems) {
      d.classList.remove('is-empty');
      if (inner) inner.classList.remove('is-empty');
    } else {
      d.classList.add('is-empty');
      if (inner) inner.classList.add('is-empty');
    }
  }

  /* ---- selector de regalo ------------------------------------------------ */
  function panelRegalo() { var d = cajon(); return d ? d.querySelector('[data-panel-regalo]') : null; }
  function pistaRegalo() { var d = cajon(); return d ? d.querySelector('[data-carrusel]') : null; }

  function actualizarFlechas() {
    var d = cajon(); if (!d) return;
    var p = pistaRegalo(); if (!p) return;
    var prev = d.querySelector('[data-car-prev]');
    var next = d.querySelector('[data-car-next]');
    if (prev) prev.disabled = p.scrollLeft <= 2;
    if (next) next.disabled = p.scrollLeft >= (p.scrollWidth - p.clientWidth - 2);
  }

  function medirCarrusel() {
    var d = cajon(); if (!d) return;
    var p = pistaRegalo();
    var carril = d.querySelector('.beg__carril');
    if (!p || !carril) return;
    if (p.scrollWidth > p.clientWidth + 4) carril.classList.add('beg--desborda');
    else carril.classList.remove('beg--desborda');
    actualizarFlechas();
  }

  // Después de cada repintado: si ya no hay regalo que elegir, se despliega el
  // carrito solo. Si seguía eligiendo y el panel sigue existiendo, se mantiene.
  function estadoRegalo() {
    var d = cajon(); if (!d) return;
    var panel = panelRegalo();
    if (!panel) { d.classList.remove('lb-eligiendo'); return; }
    if (d.classList.contains('lb-eligiendo')) {
      panel.hidden = false;
      medirCarrusel();
    }
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var d = cajon(); if (!d) return;

    if (t.closest('[data-abrir-regalo]')) {
      ev.preventDefault();
      var panel = panelRegalo(); if (!panel) return;
      d.classList.add('lb-eligiendo');
      panel.hidden = false;
      var p = pistaRegalo();
      if (p) {                                   // empujoncito: avisa que se desliza
        p.classList.add('beg--empuje');
        setTimeout(function () { p.classList.remove('beg--empuje'); }, 1000);
      }
      medirCarrusel();
      return;
    }

    if (t.closest('[data-volver-carrito]')) {
      ev.preventDefault();
      var panel2 = panelRegalo();
      d.classList.remove('lb-eligiendo');
      if (panel2) panel2.hidden = true;
      return;
    }

    var nav = t.closest('[data-car-prev], [data-car-next]');
    if (nav) {
      ev.preventDefault();
      var pi = pistaRegalo(); if (!pi) return;
      var card = pi.querySelector('.beg__card');
      var paso = card ? (card.getBoundingClientRect().width + 10) * 2 : 268;
      pi.scrollBy({ left: nav.hasAttribute('data-car-prev') ? -paso : paso, behavior: 'smooth' });
      setTimeout(actualizarFlechas, 420);
    }
  }, true);

  document.addEventListener('scroll', function (ev) {
    if (ev.target && ev.target.hasAttribute && ev.target.hasAttribute('data-carrusel')) actualizarFlechas();
  }, true);

  /* ---- señal de vida ----------------------------------------------------- */
  var estiloPuesto = false;
  function ponerEstilo() {
    if (estiloPuesto) return;
    estiloPuesto = true;
    var s = document.createElement('style');
    s.textContent =
      'cart-drawer.lb-cargando .drawer__inner{opacity:.35;transition:opacity .15s}' +
      'cart-drawer.lb-cargando .drawer__inner *:not(.drawer__close):not(.drawer__close *){pointer-events:none}' +
      'cart-drawer.lb-cargando .drawer__close{pointer-events:auto;opacity:1}' +
      '.lb-spin{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:5;pointer-events:none}' +
      '.lb-spin i{display:block;width:34px;height:34px;border:3px solid rgba(0,0,0,.15);border-top-color:#111;border-radius:50%;animation:lbgira .7s linear infinite}' +
      '@keyframes lbgira{to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }

  var relojSeguridad = null;
  function marcarCargando(d) {
    if (!d) return;
    ponerEstilo();
    d.classList.add('lb-cargando');
    if (!d.querySelector('.lb-spin')) {
      var sp = document.createElement('div');
      sp.className = 'lb-spin';
      sp.innerHTML = '<i></i>';
      var cont = d.querySelector('.drawer__inner') || d;
      if (getComputedStyle(cont).position === 'static') cont.style.position = 'relative';
      cont.appendChild(sp);
    }
    if (relojSeguridad) clearTimeout(relojSeguridad);
    relojSeguridad = setTimeout(function () { limpiarCargando(cajon()); }, 8000);
  }

  function limpiarCargando(d) {
    if (relojSeguridad) { clearTimeout(relojSeguridad); relojSeguridad = null; }
    if (!d) return;
    d.classList.remove('lb-cargando');
    var sp = d.querySelector('.lb-spin');
    if (sp && sp.parentNode) sp.parentNode.removeChild(sp);
  }

  /* ---- pintar respetando de verdad si hay que abrir o no ----------------- */
  function pintar(secs, abrir) {
    var d = cajon();
    if (!d) return false;
    if (!secs || !secs['cart-drawer']) return false;
    limpiarCargando(d);

    if (abrir) {
      d.renderContents({ sections: secs, id: null });   // renderContents ya abre
      sincronizarVacio();
      estadoRegalo();
      return true;
    }

    var abrirOriginal = d.open;
    d.open = function () {};
    try {
      d.renderContents({ sections: secs, id: null });
    } catch (e) {
      d.open = abrirOriginal;
      return false;
    }
    sincronizarVacio();
    estadoRegalo();
    setTimeout(function () { d.open = abrirOriginal; }, 60);
    return true;
  }

  /* ---- red contra el cajón en blanco: se mide por GEOMETRÍA -------------- */
  function verificarQueSeVea() {
    setTimeout(function () {
      var d = cajon();
      if (!d || !d.classList.contains('active')) return;
      sincronizarVacio();
      if (d.classList.contains('lb-eligiendo')) return;   // el carrito está plegado a propósito
      var cuerpo = document.querySelector('#CartDrawer');
      var alto = cuerpo ? cuerpo.getBoundingClientRect().height : 0;
      if (alto > 10) return;
      fetchOriginal('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.item_count > 0) refrescar(true); })
        .catch(function () {});
    }, 600);
  }

  /* ---- segundo viaje: solo si hizo falta --------------------------------- */
  var pidiendo = false;
  function refrescar(abrir) {
    var d = cajon();
    if (!d || pidiendo) return;
    pidiendo = true;
    fetchOriginal('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: {}, sections: SECCIONES, sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!pintar(data && data.sections, abrir)) {
          limpiarCargando(d);
          if (abrir) d.open();
        }
      })
      .catch(function () { limpiarCargando(d); if (abrir) d.open(); })
      .then(function () { pidiendo = false; });
  }

  /* ---- SUMAR las secciones del cajón, nunca pisar las de la página ------- */
  function unirSecciones(previas) {
    var lista = String(previas || '').split(',')
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return !!s; });
    SECCIONES.split(',').forEach(function (s) {
      if (lista.indexOf(s) === -1) lista.push(s);
    });
    return lista.join(',');
  }

  function conSecciones(init) {
    try {
      if (!init || !init.body) return init;
      var b = init.body;
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        b.set('sections', unirSecciones(b.get('sections')));
        if (!b.get('sections_url')) b.set('sections_url', location.pathname);
        return init;
      }
      if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
        b.set('sections', unirSecciones(b.get('sections')));
        if (!b.get('sections_url')) b.set('sections_url', location.pathname);
        return init;
      }
      if (typeof b === 'string') {
        var o = JSON.parse(b);
        if (o && typeof o === 'object') {
          o.sections = unirSecciones(o.sections);
          if (!o.sections_url) o.sections_url = location.pathname;
          var copia = {};
          for (var k in init) copia[k] = init[k];
          copia.body = JSON.stringify(o);
          return copia;
        }
      }
    } catch (e) {}
    return init;
  }

  /* ---- 1) agregar al carrito -------------------------------------------- */
  window.fetch = function (input, init) {
    var url = '';
    try { url = (input && input.url) ? input.url : String(input || ''); } catch (e) {}

    if (/\/cart\/add/.test(url)) {
      var d = cajon();
      var abrir = huboGesto();                          // sin dedo humano, no se abre nada
      if (d && abrir) { d.open(); marcarCargando(d); }

      var esRequest = (typeof Request !== 'undefined' && input instanceof Request);
      var p = fetchOriginal(input, esRequest ? init : conSecciones(init));

      p.then(function (r) {
        if (!r || !r.ok) { limpiarCargando(d); return; }
        r.clone().json()
          .then(function (data) {
            if (!pintar(data && data.sections, abrir)) refrescar(abrir);
            if (abrir) verificarQueSeVea();
          })
          .catch(function () { refrescar(abrir); });
      }, function () { limpiarCargando(d); });

      return p;
    }

    if (/\/cart\/(change|clear)/.test(url)) {
      var p2 = fetchOriginal.apply(this, arguments);
      p2.then(function (r) { if (r && r.ok) refrescar(false); }, function () {});
      return p2;
    }

    return fetchOriginal.apply(this, arguments);
  };

  /* ---- 2) el carrito nunca es una página nueva --------------------------- */
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (!/^\/cart(\?|$)/.test(href)) return;      // /checkout y el resto: navegación normal
    if (location.pathname === '/cart') return;    // ya estás ahí, no la rompas
    var d = cajon();
    if (!d) return;
    ev.preventDefault();
    d.open(a);
    refrescar(false);
    verificarQueSeVea();
  }, true);

  /* ---- 3) elegir el regalo ----------------------------------------------
     DOS COSAS QUE PARECEN DETALLE Y NO LO SON:
     · FORMATO {id, quantity} — NUNCA {items:[...]}. Ver "LA MINA" arriba: con
       items[] este producto regalo BORRA los perfumes pagados del carrito.
     · NO se toca el textContent del botón: eso borraría la FOTO de la tarjeta.
       Se marca con una clase. */
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('[data-regalo]') : null;
    if (!b || b.disabled || b.classList.contains('beg--cargando')) return;
    ev.preventDefault();
    var vid = Number(b.getAttribute('data-regalo'));
    b.classList.add('beg--cargando');
    window.fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    }).catch(function () { b.classList.remove('beg--cargando'); });
  }, true);
})();